import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { trpc } from '../../lib/trpc';
import { usePageTitle } from '../../lib/usePageTitle';

export const Route = createFileRoute('/household/create')({
  component: CreateHouseholdPage,
});

function CreateHouseholdPage() {
  usePageTitle('Skapa hushåll');
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const mutation = trpc.household.create.useMutation({
    onSuccess: () => void navigate({ to: '/' }),
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    mutation.mutate({ name: name.trim() });
  };

  return (
    <div className="mx-auto mt-8 max-w-sm sm:mt-16">
      <div className="rounded-2xl border border-border bg-card p-6 sm:p-7">
        <span
          aria-hidden
          className="flex size-12 items-center justify-center rounded-full bg-muted text-2xl"
        >
          🏡
        </span>
        <h1 className="mt-4 text-2xl font-semibold tracking-tight">Skapa hushåll</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Ett hushåll samlar konton, budget och räkningar som ni delar.
        </p>
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="household-name">Hushållsnamn</Label>
            <Input
              id="household-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="t.ex. Familjen Johansson"
              className="h-10"
            />
          </div>
          {mutation.error && (
            <p role="alert" className="rounded-lg bg-negative-soft px-3 py-2 text-sm text-negative">
              {mutation.error.message}
            </p>
          )}
          <Button
            type="submit"
            disabled={mutation.isPending || !name.trim()}
            className="w-full"
            size="lg"
          >
            {mutation.isPending ? 'Skapar…' : 'Skapa hushåll'}
          </Button>
        </form>
      </div>
    </div>
  );
}
